import React from 'react'

import { AccordionsPartProps } from './accordions.d';

import Accordions from '/react4xp/components/Accordions';

function AccordionsPart(props: AccordionsPartProps) {
    return <Accordions {...props} />
}

export default (props) => <AccordionsPart {...props} /> 
